import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
export const IconRefresh = props => /*#__PURE__*/_jsx("svg", {
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 0h16v16H0z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.6 8c0 3.088-2.512 5.6-5.6 5.6A5.606 5.606 0 0 1 2.4 8c0-3.088 2.512-5.6 5.6-5.6 1.496 0 2.902.582 3.96 1.64.076.076.143.16.215.24h-1.38v.934h2.798v-2.8h-.933v1.014c-.014-.015-.027-.033-.041-.047A6.492 6.492 0 0 0 8 1.467 6.541 6.541 0 0 0 1.467 8 6.541 6.541 0 0 0 8 14.533 6.541 6.541 0 0 0 14.533 8H13.6Z",
      fill: "currentColor",
      fillRule: "nonzero"
    })]
  })
});
//# sourceMappingURL=es/Icon/Refresh.js.map